import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PagingResponseModel } from "../shared/api-response.model";
import { ApiVisa } from "../shared/api-visa.model";
import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { Core2Config } from "../shared/core2Config";
import { Pagination } from "../shared/pagination.model";
import { PostCommentWithReactionContainerModel } from '../../../../../models/aggregates/post-comment-with-reaction';

@Injectable({
  providedIn: 'root'
})
export class PostCommentWithReactionService extends BaseApiTemplateService<PostCommentWithReactionContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comments-and-login-subject-reactions/post-comments-with-reactions/login-entity-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comments-and-login-subject-reactions/post-comments-with-reactions/login-entity-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comments-and-login-subject-reactions/post-comments-with-reactions/login-entity-ep';
    this.httpClient = http;
  }

  public getCommentWithReaction(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<PostCommentWithReactionContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<PostCommentWithReactionContainerModel>>(UrlByCriteria, this.getHttpHeader(visa))
  }

}


